import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getAllPpeComponentQuery = (val) => {
    return axios.get(`${apiurl?.getAllPpeComponent}?${val ? `isAdhoc=${val}&` : ''}isAll=true`);
};
export default getAllPpeComponentQuery;
